import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledTitleSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness2,
    marginBottom: theme.spacing(2),
}));

const StyledItemSkeleton = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(2),
    display: "flex",
}));

const StyledItemSkeletonThumbnail = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginRight: theme.spacing(2),
}));

const StyledItemSkeletonLineWrapper = styled("div")({
    flexGrow: 1,
});

const StyledItemSkeletonLine = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginBottom: theme.spacing(2),
}));

function ItemSkeleton() {
    const theme = useTheme();

    return (
        <StyledItemSkeleton>
            <StyledItemSkeletonThumbnail variant="rectangular" height={"80px"} width={"144px"} />
            <StyledItemSkeletonLineWrapper>
                <StyledItemSkeletonLine variant="rectangular" height={theme.spacing(2)} />
                <StyledItemSkeletonLine variant="rectangular" height={theme.spacing(2)} width={"50%"} />
            </StyledItemSkeletonLineWrapper>
        </StyledItemSkeleton>
    );
}

/**
 * media-page sidebar skeleton
 */
export function SidebarSkeleton() {
    const theme = useTheme();

    return (
        <div>
            <StyledTitleSkeleton variant="rectangular" height={theme.spacing(2.5)} width={"120px"} />

            <ItemSkeleton />
            <ItemSkeleton />
            <ItemSkeleton />
        </div>
    );
}

export default SidebarSkeleton;
